<template>
  <div class="financial padding80">
    <Header :current="0"></Header>
    <Card ref="Card" cardIndex="4"></Card>
    <LeiMon :LeiMonList="LeiMonList" @moreModel="moreModel"></LeiMon>
    <Footer></Footer>
  </div>
</template>

<script>
import cardMixins from "@/mixins/cardMixins";

export default {
  name: "financial",
  mixins: [cardMixins],
  data() {
    return {
      LeiMonList: [
        {
          icon: require("../../assets/phone/solution1.png"),
          iconPosition: "left",
          title: "金融直播运营解决方案",
          tips:
            "私有化定制企业的互联网金融直播间，含服务器软硬件资\n" +
            "源支持、直播平台后期维护、直播承制服务、直播运营支\n" +
            "持等全流程服务。",
          more: "",
          type: "financial",
          id:'images0',
          changeType:false,
        },
        {
          icon: require("../../assets/phone/solution3.png"),
          iconPosition: "right",
          title: "社群运营解决方案",
          tips:
            "通过社群运营的方式支持全渠道获客；同时，激活银行私域\n" +
            "流量，提升流量转化率，降低获客成本，提高用户留存率，\n" +
            "最大化存量用户价值。",
          more: "",
          type: "community",
          id:'images1',
          changeType:false,
        },
        {
          icon: require("../../assets/phone/solution2.png"),
          iconPosition: "left",
          title: "互联网全栈运营解决方案",
          tips:
            "通过输出全栈运营解决方案，针对性地解决中小企业、银\n" +
            "行等在线上运营过程中遇到的实际业务问题，帮助其构建\n" +
            "品牌形象，提升品牌音量。",
          more: "",
          type: "internet",
          id:'images2',
          changeType:true,
        }
      ]
    };
  },
  mounted() {},
  methods: {
    moreModel(item) {
      this.$router.push({
        path: "/solutionDetail",
        query: { type: item.type }
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
